<template>
    <div class="news-container">
        <Nav :currentActive="'News'" />

        <div class="news-banner">
            <div class="banner">
                <img src="@/assets/images/news-banner.jpg" />
            </div>
            <div class="banner-desc">
                <div class="banner-desc-text">
                    <div class="title">新闻中心</div>
                    <div class="title-en">News</div>
                </div>
                
            </div>
        </div>


        <div class="news-list pt60 pb90">
            <div class="contain">
                <!-- <div class="news-nav flex flex-justify-between flex-align-center">
                    <ul class="flex">
                        
                        <li class=""><a href="/News/1" ondragstart="return false">最新资讯</a></li>
                        
                        <li class=""><a href="/list_11" ondragstart="return false">行业动态</a></li>
                        
                        <li class=""><a href="/list_12" ondragstart="return false">技术前沿</a></li>
                        
                        <li class=""><a href="/list_13" ondragstart="return false">大事记</a></li>
                        
                       
                    </ul>
                    <form action="https://guiamacau.com/xinwen" class="nav-search" method="get" id="news_form">
                        <input type="text" name="keyword">
                        <a href="javascript:;" class="submit-btn" ondragstart="return false"><svg viewBox="0 0 1024 1024" width="20" height="20" fill="currentcolor"><path d="M192 480a256 256 0 1 1 512 0 256 256 0 0 1-512 0m631.776 362.496-143.2-143.168A318.464 318.464 0 0 0 768 480c0-176.736-143.264-320-320-320S128 303.264 128 480s143.264 320 320 320a318.016 318.016 0 0 0 184.16-58.592l146.336 146.368c12.512 12.48 32.768 12.48 45.28 0 12.48-12.512 12.48-32.768 0-45.28"></path></svg></a>
                    </form>
                </div> -->
                <Page01 v-if="nowPage == 1"/>
                <Page02 v-if="nowPage == 2"/>
                <Page03 v-if="nowPage == 3"/>
                <Page04 v-if="nowPage == 4"/>
                <Page05 v-if="nowPage == 5"/>
                <Page06 v-if="nowPage == 6"/>
                <Page07 v-if="nowPage == 7"/>
                <Page08 v-if="nowPage == 8"/>
                <Page09 v-if="nowPage == 9"/>
                <Page10 v-if="nowPage == 10"/>
                <Page11 v-if="nowPage == 11"/>
                <Page12 v-if="nowPage == 12"/>
                <Page13 v-if="nowPage == 13"/>
                <Page14 v-if="nowPage == 14"/>
                <Page15 v-if="nowPage == 15"/>
                <div class="paging">
                    <div class="paging-menu">
                        <a ondragstart="return false" @click="prePage">上一页</a>
                        <a class="page-num" ondragstart="return false" v-if="nowPage > 3">···</a>
                        <a ondragstart="return false" v-if="nowPage > 2"  @click="gotoPage(nowPage - 2)">{{ nowPage - 2 }}</a>
                        <a ondragstart="return false" v-if="nowPage > 1"  @click="gotoPage(nowPage - 1)">{{ nowPage - 1 }}</a>
                        <a ondragstart="return false" class="active">{{ nowPage }}</a>
                        <a ondragstart="return false" v-if="nowPage + 1 < 15"  @click="gotoPage(nowPage + 1)">{{ nowPage + 1 }}</a>
                        <a ondragstart="return false" v-if="nowPage + 2 < 15"  @click="gotoPage(nowPage + 2)">{{ nowPage + 2 }}</a>
                        <a ondragstart="return false" v-if="nowPage < 2"  @click="gotoPage(4)">{{ 4 }}</a>
                        <a ondragstart="return false" v-if="nowPage < 3"  @click="gotoPage(5)">{{ 5 }}</a>
                        <a class="page-num" ondragstart="return false" v-if="nowPage + 3 < 15">···</a>
                        <a ondragstart="return false" @click="nextPage">下一页</a>
                    </div>
                </div>

            </div>
        </div>
        <Footer />
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted, watch } from 'vue';
  import Nav from '../../components/NavTop.vue';
  import Footer from '../../components/Footer.vue';
  import { useRoute, useRouter } from 'vue-router';

  import Page01 from './pages/page_01.vue'
  import Page02 from './pages/page_02.vue'
  import Page03 from './pages/page_03.vue'
  import Page04 from './pages/page_04.vue'
  import Page05 from './pages/page_05.vue'
  import Page06 from './pages/page_06.vue'
  import Page07 from './pages/page_07.vue'
  import Page08 from './pages/page_08.vue'
  import Page09 from './pages/page_09.vue'
  import Page10 from './pages/page_10.vue'
  import Page11 from './pages/page_11.vue'
  import Page12 from './pages/page_12.vue'
  import Page13 from './pages/page_13.vue'
  import Page14 from './pages/page_14.vue'
  import Page15 from './pages/page_15.vue'
  
  const startAnimate = ref(false)
  const nowPage = ref(1);

    const route = useRoute();
    const router = useRouter();

    const gotoPage = (id) => {
        router.push({ name: 'News', params: { id: id } });
    }


    // 监听路由参数变化
    watch(
        () => route.params.id,
        (newNumber) => {
            // 当参数变化时，这里可以执行更新逻辑
            console.log('数字参数已更新为:', newNumber);
            nowPage.value = newNumber - 0
            // 比如重新获取数据等操作
            // 手动将页面滚动到顶部
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth' // 可以根据需要设置滚动的动画效果，'smooth' 表示平滑滚动
            });
        },
        { immediate: true } // 初始化时也会触发一次
    );
    const prePage = () => {
        if(nowPage.value > 1){
            nowPage.value = nowPage.value - 1
            router.push({ name: 'News', params: { id: nowPage.value } });
        }
        
    }
    const nextPage = () => {
        if(nowPage.value < 11){
            nowPage.value = nowPage.value + 1
            router.push({ name: 'News', params: { id: nowPage.value } });
        }
    }
  onMounted(() => {
    startAnimate.value = true
    nowPage.value = route.params.id - 0;

  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

    .paging {
        width: 100%;
        font-size: 0;
        text-align: center;
        margin-top: 50px;
        user-select: none;
    }
    .paging-menu, .paging-menu a, .paging-skip, .paging-hint, .paging-skip input, .paging-skip button {
        display: inline-block;
        vertical-align: middle;
    }


    .paging-menu a {
        width: 38px;
        height: 38px;
        border: 1px solid #f3f3f3;
        margin: 4px;
        font-size: 18px;
        color: #666;
        transition: all .4s ease;
        border-radius: 3px;
        background-color: #fff;
        display: inline-flex    ;
        align-items: center;
        justify-content: center;
        font-weight: 500;
    }
    /* .paging-menu, .paging-menu a, .paging-skip, .paging-hint, .paging-skip input, .paging-skip button {
        display: inline-block;
        vertical-align: middle;
    } */
    
    .paging-menu a:first-child, .paging-menu a:last-child {
        width: 86px;
        font-size: 16px;
    }
    .paging-menu a:hover, .paging-menu a.active, .paging a.on {
        border-color: #1c4892;
        background-color: #1c4892;
        color: #FFFFFF;
    }

  </style>